import {Input} from "./Input";
import './css/Request.css'
import axios from "axios";
import {host} from "../App";
import {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import {objects} from "../objects";
import ReactDOMServer from "react-dom/server";
import {fields} from "../fields";
import {useLoader} from "./hooks/useLoader";


export const Request = (props) => {

    const [error, setError] = useState(false);
    const [content, setContent] = useState('');
    const [inputContent, setInputContent] = useState('');
    const [width, setWidth] = useState("70%");
    const {showLoader, hideLoader} = useLoader();

    function sendRequest(mapping) {

        let config = {
            headers: {
                apiName: document.getElementById('apiName').value,
                apiKey: document.getElementById('apiKey').value,
                userId: document.getElementById('user').value,
                'Content-Type': 'application/json'
            }
        }
        const link = host + props.request.requestName;
        const preview = document.getElementById('preview');
        let promise;
       showLoader()
        switch (mapping) {
            case 'PUT':
                promise = axios.put(link, preview.value, config)
                break;
            case 'GET':
                if (link.includes('/v3/files')) {
                    let filename;
                    axios.get(preview ? preview.value : link, {
                        headers: {
                            apiName: document.getElementById('apiName').value,
                            apiKey: document.getElementById('apiKey').value,
                            userId: document.getElementById('user').value,
                            'Content-Type': 'application/json'
                        },
                        responseType: 'blob'
                    })
                        .then(response => {
                            const disposition = response.headers['content-disposition'];
                            filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
                            if (filename.toLowerCase().includes('utf8')) {
                                filename = decodeURIComponent(escape(window.atob(filename.replace('"=?utf8?B?', '').replace('==?="', ''))));
                            } else {
                                filename = filename.replace(/['"]/g, '');
                            }
                            return response.data;
                        })
                        .then(blob => {
                            var url = window.URL.createObjectURL(blob);
                            var a = document.createElement('a');
                            a.href = url;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                            a.remove();
                            hideLoader()
                        })
                        .catch(error => {
                            console.error(error);
                            hideLoader()
                        });
                }
                else {
                    promise = axios.get(preview ? preview.value : link, config)
                }
                break;
            case 'POST':
                promise = axios.post(link, preview.value, config)
                break;
            case 'DELETE':
                config.data = preview.value
                promise = axios.delete(link, config)
                break;
            default:
                promise = axios.get(preview ? preview.value : link, config)
                break;
        }
        if (promise) {
            promise.then((resp) => {
                document.getElementById("response").innerHTML = JSON.stringify(resp.data, null, 2)
                document.getElementById("status").innerHTML = 'Status: ' + resp.status
                hideLoader()
            });
            promise.catch(function (error) {
                if (error.request) {
                    document.getElementById("response").innerHTML = 'Wrong api credentials'
                    document.getElementById("status").innerHTML = 'Status: ' + 403
                }
                hideLoader()
            });
        }
    }

    function fillValue(id, value) {
        let element = null;
        for (const elementsByTagNameElement of document.getElementsByTagName('INPUT')) {
            if (elementsByTagNameElement.id === id) {
                element = elementsByTagNameElement;
            }
        }
        if (!element) {
            element = document.getElementById(id);
        }
        if (value) {
            if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    var p = {name: id, required: false, type: fields[id].type}
                    document.getElementById(id).innerHTML = id
                    let count = 0;
                    for (const valueElement of value) {
                        const className = Math.random().toString(36).substring(2, 9)
                        const div = document.createElement('div');
                        div.innerHTML = ReactDOMServer.renderToString(<>
                            <hr/>
                            <button id={className} style={{
                                border: "none",
                                color: "red",
                                backgroundColor: "transparent",
                                marginRight: "25%"
                            }}>Remove
                            </button>
                            {f(p.type.replace('[', '').replace(']', ''), true, count, p, valueElement)}</>)
                        count++
                        div.className = 'group ' + className
                        document.getElementById(p.name).appendChild(div);
                        document.getElementById(className).addEventListener("click", function () {
                            const element = document.getElementsByClassName(className);
                            const parent = document.getElementById(id);
                            if (element) {
                                parent.removeChild(element[0]);
                                props.fillPostReq()
                            }
                        })
                        const container = document.getElementsByClassName(className);
                        const inputs = container[0].getElementsByTagName('INPUT');
                        for (const input of inputs) {
                            input.addEventListener("input", (event) => {
                                changeHandler(event, input.id)
                            })
                        }
                    }
                } else {
                    for (const objectsKey of Object.keys(value)) {
                        fillValue(objectsKey, value[objectsKey])
                    }
                }
            } else {
                if (element.type === 'date') {
                    var date = new Date(value);
                    const offset = date.getTimezoneOffset()
                    date = new Date(date.getTime() - (offset * 60 * 1000))
                    element.value = date.toISOString().split('T')[0]
                } else {
                    element.value = value
                }
            }
        } else {
            if (element.tagName === 'DIV') {
                for (let i = 0; i < element.children.length; i++) {
                    if (element.children[i].id) {
                        fillValue(element.children[i].id, null)
                    } else {
                        fillValue(element.getElementsByTagName('INPUT')[0].id, null)
                    }
                }
            } else {
                element.value = ''
            }
        }
    }

    function f(type, isArray, count, param, inputMap) {
        var objectsArray = []
        if (type.startsWith('[')) {
            objectsArray.push(<>
                <div id={param.name}>{param.name}</div>
                <button style={{border: "none", color: "#348034", backgroundColor: "transparent", marginRight: "25%"}}
                        onClick={() => {
                            const className = Math.random().toString(36).substring(2, 9)
                            const div = document.createElement('div');
                            div.innerHTML = ReactDOMServer.renderToString(<>
                                <hr/>
                                <button id={className} style={{
                                    border: "none",
                                    color: "red",
                                    backgroundColor: "transparent",
                                    marginRight: "25%"
                                }}>Remove
                                </button>
                                {f(type.replace('[', '').replace(']', ''), true, count, param)}</>)
                            count++
                            div.className = 'group ' + className
                            document.getElementById(param.name).appendChild(div);
                            document.getElementById(className).addEventListener("click", function () {
                                const element = document.getElementsByClassName(className);
                                const parent = document.getElementById(param.name);
                                if (element) {
                                    parent.removeChild(element[0]);
                                    fillPostReq()
                                }
                            })
                            const container = document.getElementsByClassName(className);
                            const inputs = container[0].getElementsByTagName('INPUT');
                            for (const input of inputs) {
                                input.addEventListener("input", (event) => {
                                    changeHandler(event, input.id)
                                })
                            }
                        }}>Add
                </button>
            </>)
        } else if (objects[type]) {
            const inner = f1(objects[type], isArray, count, inputMap);
            const div = <div id={isArray ? '' : param.name}>{!isArray && param.name} {inner}</div>;
            objectsArray.push(div)
        } else {
            objectsArray.push(<div className="input-container">
                <label htmlFor={param.name}>
                    {param.name}
                    {param.required && <span style={{color: "red"}}> *</span>}
                </label>
                <input style={{width: width, borderColor: "#969696"}}
                       id={isArray ? param.name +  count : param.name}
                       type={type}
                       className="param-input"
                       onChange={(e) => changeHandler(e, param.name)}
                       required={param.required}
                />
                {type}
            </div>)
        }
        return objectsArray;
    }

    function fillPostReq() {
        var request = new Object();
        {
            props.request.params.map((p, i) => (
                JSON.stringify(getRequest(p.type, p.name, request), (key, value) => {
                    if (value !== null) {
                        return value
                    }
                })
            ))
        }
        if (document.getElementById('preview')) {
            document.getElementById('preview').value = JSON.stringify(request, (key, value) => {
                if (value !== null) return value
            })
        }
    }

    function changeHandler(evt, id) {
        setInputContent(evt.target.value);
        const element = document.getElementById(id);
        if (evt.target.value && element.getAttribute("style").includes("border-color:red")) {
            element.setAttribute("style", element.getAttribute("style").replace("border-color:red", "border-color: rgb(150, 150, 150)"));
        }
        if (props.request.mapping !== 'GET') {
            fillPostReq()
        } else {
            buildUrl(evt, props.request.requestName)
        }
    };

    function buildObject(id, value, obj, isInput) {
        if (value) {
            obj[id.replace(/[0-9]/g, '')] = value
        } else if (!isInput) {
            var objectInner = new Object();
            let inner = null;
            for (const elementsByTagNameElement of document.getElementsByTagName('DIV')) {
                if (elementsByTagNameElement.id === id) {
                    inner = elementsByTagNameElement;
                }
            }
            if (!inner) {
                inner = document.getElementById(id);
            }
            for (let i = 0; i < inner.children.length; i++) {
                if (inner.children[i].id) {
                    buildObject(inner.children[i].id, null, objectInner)
                } else {
                    const input = inner.children[i].getElementsByTagName('INPUT')[0];
                    buildObject(input.id.replace(/[0-9]/g, ''), input.value, objectInner, true)
                }
            }
            obj[id.replace(/[0-9]/g, '')] = objectInner
        }
    }

    function getInnerObj(object) {
        var obj = new Object()

        Object.keys(object).map((key, i) => {
            if (typeof object[key] === 'object') {
                obj[key] = getInnerObj(object[key], key)
            } else {
                for (const elementsByTagNameElement of document.getElementsByTagName('INPUT')) {
                    if (elementsByTagNameElement.id === key) {
                        if (elementsByTagNameElement && elementsByTagNameElement.value) {
                            if (elementsByTagNameElement.type === 'date') {
                                const date = new Date(elementsByTagNameElement.value);
                                const milliseconds = date.getTime();
                                obj[key] = milliseconds;
                            } else {
                                obj[key] = elementsByTagNameElement.value;
                            }
                        } else {
                            obj[key] = null
                        }
                    }
                }
            }
        })
        return obj
    }


    function buildUrl(evt, req) {
        let url = host + req + '?';
        let previousLink = document.getElementById('preview').value.replace(url, '')
        const urlParams = new URLSearchParams(previousLink);
        if (evt.target.value) {
            urlParams.set(evt.target.id, evt.target.value);
        } else {
            urlParams.delete(evt.target.id);
        }
        let params = decodeURIComponent(urlParams.toString());
        if (!params) {
            document.getElementById('preview').value = ''
        } else {
            document.getElementById('preview').value = url + params
        }
    }

    function f1(object, isArray, count, inputMap) {
        var innerObjectsArray = []
        Object.keys(object).map((key, i) => {
                if (typeof object[key] === 'object') {
                    const inner = f1(object[key], isArray, count, inputMap ? inputMap[key] : null);
                    const div = <div id={isArray ? key + count : key} style={{paddingLeft: "5%"}}>{key}{inner}</div>;
                    innerObjectsArray.push(div)
                } else {
                    innerObjectsArray.push(<div style={{paddingLeft: "5%"}} className="input-container">
                        <label htmlFor={isArray ? key + count : key}>
                            {key}
                        </label>
                        <input style={{width: width, borderColor: "#969696"}}
                               id={isArray ? key + count : key}
                               type={object[key]}
                               className="param-input"
                               onChange={(e) => changeHandler(e, key)}
                               required={false}
                               value={inputMap ? inputMap[key] : ''}
                        />
                        {object[key]}
                    </div>);
                }
            }
        )
        return innerObjectsArray
    }

    useEffect(() => {
                if (props.request.mapping !== 'GET') {
                try {
                let preview = document.getElementById('preview').value
                if (!preview) {
                preview = '{}'
            }
                const parse = JSON.parse(preview);
                for (const p of props.request.params) {
                fillValue(p.name, parse[p.name])
            }
                if (!parse) {
                document.getElementById('preview').value = ''
            }
                setError(false)
            } catch (ex) {
                if (document.getElementById('preview') && document.getElementById('preview').value) {
                setError(true)
            } else {
                for (const p of props.request.params) {
                if (document.getElementById(p.name)) {
                document.getElementById(p.name).value = ''
            }
            }
                setError(false)
            }
            }
            } else {
                const preview = document.getElementById('preview');
                if (preview && preview.value) {
                let previousLink = preview.value.replace(host + props.request.requestName, '').replace('?', '')
                const urlParams = new URLSearchParams(previousLink);
                for (const p of props.request.params) {
                document.getElementById(p.name).value = urlParams.get(p.name)
            }
                if (!urlParams.size) {
                preview.value = ''
            }
            }
            }
            }, [content]);


                function getRequest(type, id, obj) {
                if (type.startsWith('[')) {
                let array = [];
                const arrayContainer = document.getElementById(id);
                const divs = arrayContainer.getElementsByClassName('group');
                for (const div of divs) {
                const object = {};
                const innerDivs = div.getElementsByTagName('DIV');
                if (innerDivs) {
                if (innerDivs[0].className === 'input-container') {
                const input = innerDivs[0].getElementsByTagName('INPUT')[0];
                array.push(input.value)
            } else {
                for (let i = 0; i < innerDivs[0].children.length; i++) {
                if (innerDivs[0].children[i].id) {
                buildObject(innerDivs[0].children[i].id, null, object)
            } else {
                const input = innerDivs[0].children[i].getElementsByTagName('INPUT')[0];
                if (input.type === 'date') {
                const date = new Date(input.value);
                const milliseconds = date.getTime();
                buildObject(input.id, milliseconds, object, true)
            } else {
                buildObject(input.id, input.value, object, true)
            }
            }
            }
                array.push(object)
            }
            }
            }
                obj[id] = array;
            } else if (objects[type]) {
                obj[id] = getInnerObj(objects[type], obj);
            } else {
                const elementById = document.getElementById(id);
                if (elementById && elementById.value) {
                if (type === 'Date') {
                const date = new Date(elementById.value);
                const milliseconds = date.getTime();
                obj[id] = milliseconds;
            } else {
                obj[id] = elementById.value;
            }
            } else {
                obj[id] = null
            }
        }
        return obj
    }

    const isUploading = props.request.mapping === 'POST' && props.request.requestName === '/api/v3/files';
    return (
        <>
            <div style={{marginBottom: '5%'}}>{<FormattedMessage
                id={props.request.mapping + props.request.requestName + 'descr'}/>}</div>
            <div style={{marginBottom: '5%'}}>
                {isUploading &&
                    <div style={{marginBottom: "5%"}}>
                        <input id="file-vacancy" style={{display: "none"}} className="hidden" type="file"
                               onChange={(e) => {
                                   const files = e.target.files;
                                   var formData = new FormData();
                                   formData.append("Files", files[0]);
                                   let config = {
                                       headers: {
                                           apiName: document.getElementById('apiName').value,
                                           apiKey: document.getElementById('apiKey').value,
                                           userId: document.getElementById('user').value,
                                           'Content-Type': 'multipart/form-data'
                                       }
                                   }
                                   const link = host + props.request.requestName;
                                   const promise = axios.post(link, formData, config);
                                   promise.catch(function (error) {
                                       if (error.request) {
                                           document.getElementById("response").innerHTML = 'Wrong api credentials'
                                           document.getElementById("status").innerHTML = 'Status: ' + 403
                                       }
                                   });
                                   promise.then((resp) => {
                                       document.getElementById("response").innerHTML = JSON.stringify(resp.data, null, 2)
                                       document.getElementById("status").innerHTML = 'Status: ' + resp.status
                                   });
                               }
                               }/>
                        <label style={{width: '20%'}} className="submit" htmlFor="file-vacancy">
                            <FormattedMessage id='Select file'/>
                        </label>
                    </div>}
                {props.request.params.map((p, i) => (
                    <Input key={i} param={p} f={f}></Input>
                ))}
                {props.request.params.length > 0 &&

                    <FormattedMessage id='Request preview'>
                        {(msg) => (
                            <textarea style={{height: "100px", width: "80%", borderColor: error ? "red" : "black"}}
                                      id='preview'
                                      placeholder={msg}
                                      onChange={(e) => setContent(e.target.value)}
                            ></textarea>)}
                    </FormattedMessage>

                }
                {!isUploading && <button className="submit" onClick={(e) => {
                    let isFull = true
                    var inputs = document.getElementsByTagName('input')
                    let index;
                    for (index = 0; index < inputs.length; ++index) {
                        if (inputs[index].required && !inputs[index].value) {
                            isFull = false
                            const element = document.getElementById(inputs[index].id)
                            if (element.getAttribute("style") && element.getAttribute("style").includes("border-color: rgb(150, 150, 150)")) {
                                element.setAttribute("style", element.getAttribute("style").replace("border-color: rgb(150, 150, 150)", "border-color:red"));
                            } else if (element.getAttribute("style") && element.getAttribute("style").includes("border-color:red")) {
                            } else {
                                element.setAttribute("style", "border-color:red;" + element.getAttribute("style"));
                            }
                        }
                    }
                    if (!error && isFull) {
                        sendRequest(props.request.mapping)
                    }
                }}><FormattedMessage id='Send'/>
                </button>}
            </div>
        </>
    )

}